// import { useEffect } from 'react'
import { CreditCardIcon } from '@heroicons/react/outline'
import { useEffect, useState } from 'react'
import useSWR from 'swr'
import { API } from '../../apis/API'
import { CustomerAPI, CustomerFetcher } from '../../apis/CustomerAPI'
import AddCard from '../../components/AddCard'
import ErrorAlert from '../../components/Alerts/ErrorAlert'
import InfoAlert from '../../components/Alerts/InfoAlert'
import SuccessAlert from '../../components/Alerts/SuccessAlert'
import MyAccountWrapper from '../../components/MyAccountWrapper'
import { getCustomerCards, humanizeCardFunding } from '../../helpers/checkout'
import { getErrorMessage, log } from '../../helpers/utils'

function SavedCards() {
    const { data: customer, error } = useSWR(
        CustomerAPI.getCustomer,
        CustomerFetcher,
    )

    const [cards, setCards] = useState([])
    const [loading, setLoading] = useState(true)
    const [success, setSuccess] = useState()
    const [localerror, setError] = useState()

    const fetchCards = async () => {
        const fetchedCards = await getCustomerCards(customer)
        log('fetchedCards', fetchedCards)
        setCards(fetchedCards)
        setLoading(false)
    }

    const handleDeleteCard = async ({ id, card }) => {
        try {
            await API.deleteStripeCard(id)
            setCards((cards) => cards.filter((card) => card.id !== id))
            setSuccess(
                `${card.brand} ending in ${card.last4} deleted successfully.`,
            )
        } catch (e) {
            setError(getErrorMessage(e))
        }
    }

    const deleteCard = (method) => {
        if (
            confirm(
                `Are you sure you want delete card ${method.card.brand} ending in ${method.card.last4}?`,
            )
        ) {
            handleDeleteCard(method)
        }
    }

    useEffect(() => {
        fetchCards()
    }, [customer])

    const reloadComponent = () => {
        fetchCards()
        setLoading(true)
    }

    return (
        <MyAccountWrapper
            title={'Your Saved Cards'}
            error={error}
            description={`
            ${
                customer
                    ? `Hello, ${customer?.first_name}, Here you can manage your
            saved cards.`
                    : 'Loading...'
            }`}>
            {error ? (
                'Failed to Load'
            ) : customer ? (
                <>
                    <div className="space-y-4">
                        {success && <SuccessAlert success={success} />}
                        {localerror && <ErrorAlert error={localerror} />}

                        <AddCard
                            customer={customer}
                            reloadComponent={reloadComponent}
                        />

                        {loading ? (
                            <InfoAlert>Loading saved cards...</InfoAlert>
                        ) : cards.length > 0 ? (
                            cards.map((method) => {
                                return (
                                    <div
                                        key={method.id}
                                        className="bg-white border rounded p-3 items-center justify-between flex w-full space-x-4">
                                        <div className="flex items-center space-x-4">
                                            <CreditCardIcon className="h-10 w-10 text-gray-500" />
                                            <span>
                                                {`${
                                                    method.card.brand
                                                } ending in ${
                                                    method.card.last4
                                                } - ${humanizeCardFunding(
                                                    method.card.funding ||
                                                        'unknown',
                                                )}`}
                                            </span>
                                        </div>
                                        <button
                                            className="bg-red-300 hover:bg-red-400 p-1 px-4 rounded text-sm"
                                            onClick={() => deleteCard(method)}>
                                            {' '}
                                            Delete{' '}
                                        </button>
                                    </div>
                                )
                            })
                        ) : (
                            <InfoAlert>No saved cards found.</InfoAlert>
                        )}
                    </div>
                </>
            ) : (
                'Loading...'
            )}
        </MyAccountWrapper>
    )
}

export default SavedCards
